import { render, staticRenderFns } from "./Manage_questionEdit.vue?vue&type=template&id=12d61f9e&"
import script from "./Manage_questionEdit.vue?vue&type=script&lang=js&"
export * from "./Manage_questionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports